<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('TestOrdersResultSetupL.Title')}}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">                      
                        <MdButton
                            v-bind:Label="$t('TestOrdersResultSetupL.AddSetup')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddTestResultSetups"
                            v-bind:Name="'btn_add_vendor'">
                        </MdButton>
                    </div>

                    <div  v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-9 mb-4':'col-sm-12 col-md-12 mb-4'">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchTestResultSetup"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchTestResultSetup">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="EditTestResultSetups"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="RemoveTestResultSetups"
                            v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TestOrderResultSetupService from '@/services/testorderresultsetup.service';
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission'
import CPTService from '@/services/cpt.service'
import PatientService from '@/services/patient.service'


export default {
    name: 'TestOrdersResultSetupListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu:{
                 visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                Mode:this.edit_mode,
                favButtonAtion:false 
            }, 
            parameter: {
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0 ,
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                { key: 'longName', sortable: true, label:  this.$t('TestOrdersResultSetupL.LongD'), class: 'text-left' },
                { key: 'procType', sortable: true, label: this.$t('TestOrdersResultSetupL.Pt'), class: 'text-left' },
                { key: 'unit', sortable: true, label: this.$t('Shared.Unit'), class: 'text-left' },
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-right hidden' },
                { key: 'cptcode', sortable: true, label: this.$t('DrugInventoryItem.CPTCode'), class: 'text-right' },
                { key: 'cpt', sortable: true, label: this.$t('Shared.CPT')},
                { key: 'diagCode', sortable: true, label: this.$t('Shared.DiagnosisCode'), class: 'text-right' },
                { key: 'diagDescription', sortable: true, label: this.$t('Shared.DiagnosisDescription')},
                { key: 'highRange', sortable: true, label: this.$t('TestOrdersResultSetupL.HighRange'), class: 'text-center' },
                { key: 'loincCode', sortable: true, label: 'LOINC Code', class: 'text-right' },
                { key: 'lowRange', sortable: true, label: this.$t('TestOrdersResultSetupL.LowR'), class: 'text-center' },
                { key: 'rxNorm', sortable: true, label: 'RxNorm', class: 'text-right' },
                { key: 'unitPrice', sortable: true, label:this.$t('Shared.UnitPrice'), class: 'text-center' },
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty:false,
            Mode:'', 
        }
    },

    methods: {
        AddTestResultSetups() {
            this.Mode = "Add";
            this.emitDataforFavorites();  
            this.$emit('onUpdatedMenu', '');  
            this.$router.push({ name: "TestOrderSetupAdd" })
        },

        async getTestResultSetups() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            try {
                const response = await TestOrderResultSetupService.getAllListing(this.parameter);
                
                if (response.status == '200' && response.data) {
                    // Limpiar items antes de llenar con nueva página
                    this.items = [];
                    
                    // IMPORTANTE: Esperar a que TODAS las descripciones se resuelvan
                    const itemsWithDescriptions = await this.enrichItemsWithDescriptions(response.data);
                    this.items = itemsWithDescriptions;
                    
                    // Procesar paginación
                    let headerString = response.headers["x-pagination"];
                    if (headerString) {
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }
                }
                
                this.showMessageIsEmpty = this.totalRows === 0 || this.items.length === 0;
                
            } catch (error) {
                console.error('Error en getTestResultSetups:', error);
                this.showResponseErrorMessage(error);
            } finally {
                // this.loading = false;
            }
        },

        // Método separado para enriquecer items
        async enrichItemsWithDescriptions(items) {
            if (!items || items.length === 0) return [];
            
            // Crear un array de promesas para TODOS los items
            const enrichmentPromises = items.map(async (element) => {
                // Crear una copia para no modificar el original directamente
                const enrichedItem = { ...element };
                
                try {
                    if (element.diagCode) {
                        const description = await this.getAllDescription(element.diagCode, 'diagCode');
                        enrichedItem.diagDescription = description ;
                    }
                    
                    if (element.cptcode) {
                        const description = await this.getAllDescription(element.cptcode, 'cpt');
                        enrichedItem.cpt = description;
                    }
                } catch (error) {
                    console.error(`Error en item ${element.id}:`, error);
                    // No fallar todo por un item
                }
                
                return enrichedItem;
            });
            
            // Wait for all promise finish
            return await Promise.all(enrichmentPromises);
        },

        async getAllDescription(code, from) {
            try {
                if (from === "cpt") {
                    const cptParam = { code: code };
                    const response = await CPTService.getCPTByCode(cptParam);
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        return response.data[0].name;
                    }
                } else if (from === "diagCode") {
                    const response = await PatientService.getDiagnosis(code);
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        return response.data[0].name;
                    }
                }
                return null;
            } catch (error) {
                console.error(`Error , get description for ${code} (${from}):`, error);
                this.showResponseErrorMessage(error);
                return null;
            }
        },

        EditTestResultSetups(row) {
            this.Mode = "Edit";
            this.$router.push({ name: "TestOrderSetupEdit", params: {id: row.code} });
        },

        RemoveTestResultSetups(row) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_vendor'
				})
                .then(value => {
                    if(value){
                        TestOrderResultSetupService.delete(row.code)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchTestResultSetup();
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        pageChanged(page) {            
            this.currentPage = page;
            this.getTestResultSetups();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getTestResultSetups();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        onRowSelected(items) {    
           this.selected = items;
        },

        SearchTestResultSetup() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getTestResultSetups();
        },

    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getTestResultSetups();
        });
    }
}
</script>